export enum TrainerAvailability {
  NotAvailableFromAbsence = 0,
  NotAvailableFromOtherAppointments = 1,
  AvailableFromAvailability = 2,
  AvailableFromMissingInformation = 3,
  NotAvailableFromUnEmployedTrainer = 4,
}

export enum RoomAvailability {
  Free = 0,
  Occupied = 1,
  NotAvailable = 2,
}

export interface AppointmentTrainerRoomAvailability {
  appointmentId: string; //Guid
  trainerNames: string[];
  trainerAvailabilities: TrainerAvailability[];
  roomId: string;
  roomAvailability: RoomAvailability;
}

export interface AppointmentTrainerRoomAvailabilityODataRes {
  value: AppointmentTrainerRoomAvailability[];
  '@odata.context'?: string | undefined;
}

export interface AppointmentAvailabilityFaults {
  appointmentId: string;
  trainerFaults: { translationKey: string; trainerName: string }[];
  roomFault?: string;
}

export function parseAppointmentTrainerRoomAvailability(
  appointmentTrainerRoomAvailability: Partial<AppointmentTrainerRoomAvailability>
): AppointmentTrainerRoomAvailability {
  return {
    appointmentId: appointmentTrainerRoomAvailability.appointmentId ?? '',
    trainerNames: appointmentTrainerRoomAvailability.trainerNames ?? [],
    trainerAvailabilities:
      appointmentTrainerRoomAvailability.trainerAvailabilities?.map((x) =>
        typeof x === 'string'
          ? TrainerAvailability[x as keyof typeof TrainerAvailability]
          : x
      ) ?? [],
    roomId: appointmentTrainerRoomAvailability.roomId ?? '',
    roomAvailability:
      (typeof appointmentTrainerRoomAvailability.roomAvailability === 'string'
        ? RoomAvailability[
            appointmentTrainerRoomAvailability.roomAvailability as keyof typeof RoomAvailability
          ]
        : appointmentTrainerRoomAvailability.roomAvailability) ??
      RoomAvailability.Free,
  };
}

export function availabilitiesContainConflicts(
  availabilities: AppointmentTrainerRoomAvailability[]
) {
  let trainerCheckMethod = function (x: TrainerAvailability) {
    return (
      x === TrainerAvailability.NotAvailableFromAbsence ||
      x === TrainerAvailability.NotAvailableFromOtherAppointments ||
      x === TrainerAvailability.NotAvailableFromUnEmployedTrainer
    );
  };

  let conflicts = false;
  for (let availability of availabilities) {
    if (
      availability.roomAvailability == RoomAvailability.Occupied ||
      availability.roomAvailability == RoomAvailability.NotAvailable ||
      availability.trainerAvailabilities.filter(trainerCheckMethod).length > 0
    ) {
      conflicts = true;
      break;
    }
  }

  return conflicts;
}

export function assembleFaults(
  availabilities: AppointmentTrainerRoomAvailability[]
) {
  let appointmentAvailabilityFaults = [];

  for (let availability of availabilities) {
    let faultEntry: AppointmentAvailabilityFaults = {
      appointmentId: availability.appointmentId,
      trainerFaults: [],
      roomFault: undefined,
    };

    //Is the room occupied?
    if (availability.roomAvailability == RoomAvailability.Occupied) {
      faultEntry.roomFault = 'room_occupied';
    } else if (availability.roomAvailability == RoomAvailability.NotAvailable) {
      faultEntry.roomFault = 'room_not_available';
    }

    //Are trainers absent or involved in other appointments?
    for (let i = 0; i < availability.trainerAvailabilities.length; i++) {
      let trainerAvailability = availability.trainerAvailabilities[i];
      let translationKey;

      switch (trainerAvailability) {
        case TrainerAvailability.NotAvailableFromAbsence:
          translationKey = 'trainer_absent';
          break;
        case TrainerAvailability.NotAvailableFromOtherAppointments:
          translationKey = 'trainer_occupied';
          break;
        case TrainerAvailability.NotAvailableFromUnEmployedTrainer:
          translationKey = 'trainer_unemployed';
      }

      if (translationKey != undefined) {
        faultEntry.trainerFaults.push({
          translationKey: translationKey,
          trainerName: availability.trainerNames[i],
        });
      }
    }

    //Adding to the faults-list
    appointmentAvailabilityFaults.push(faultEntry);
  }

  return appointmentAvailabilityFaults;
}
